module.exports = __webpack_public_path__ + "static/media/25626308_1703516723056845_1703323076097705954_o.4a1eccf3.jpg";